module.exports = function(menus) {
	'use strict'
	menus.directive('checkedWidgetDir',checkedWidgetDir);
	checkedWidgetDir.$inject=['checkArray','$filter'];
	function checkedWidgetDir(checkArray, $filter) {
		return {
			restrict: 'E',
			scope:{
				type:'=',
				list:'=',
				parentObj:'='
			},
			replace:true,
			template: require('./partial/checkedWidget.html'),
			link: function(scope, ele, $attrs, ctrl) {
                scope.menu = []
                scope.itemChecked = {}
				scope.checkedRequired = false;
				var addedArray = []
				scope.searchData = {}
				function removeAncestors(array) {
					for(var i = 0;i<array.length;i++) {
						delete array[i].ancestors
						if(array[i].children && array[i].children.length>0) {
							removeAncestors(array[i].children)
						}
					}
				}
				function applyFilter() {
					scope.filteredList = scope.list
					var searchData = (scope.type=='category')?scope.searchData.name:scope.searchData.title 
					if(searchData) {
					  scope.filteredList = $filter('filter')(scope.filteredList,scope.searchData)
					}
				}
				scope.changeSearch = function() {
					applyFilter()
				}
				applyFilter()
                scope.addNavigationItem = function() {
					addedArray.length = 0;
					scope.checkedRequired = false
					if(scope.menu.length == 0) {
						scope.checkedRequired =true;
						return
					}
					addedArray = checkArray.reconstructArrayByAncestors(scope.menu)
					removeAncestors(addedArray)
					for(var i = 0; i<addedArray.length;i++) {
						scope.parentObj.navigationValue.push(addedArray[i])
					}
					scope.menu.length = 0;
					scope.itemChecked = {}
					scope.searchData = {}
					applyFilter()
                }
			}
		}
	}
}



//////////////////
// WEBPACK FOOTER
// ./public/development/assets/ext-modules/menusModule/menus/js/directive/checkedWidgetDirective.js
// module id = 527
// module chunks = 0